import { AsYouType } from 'libphonenumber-js';
import { E164_PHONE_NUMBER_REGEXP, US_PHONE_NUMBER_REGEXP } from '../regex/regex-constants';
/**
 * Convert a E. 164 phone number to U.S. format
 * @param phoneNumber An E. 164 phone number, e.g. +15558576309
 * @returns U.S. formatted phone number, e.g. (555) 857-6309
 */
export const formatE164ToUSPhoneNumber = (phoneNumber) => {
    const groups = phoneNumber?.match(E164_PHONE_NUMBER_REGEXP);
    try {
        if (!groups) {
            return phoneNumber;
        }
        return `(${groups[2]}) ${groups[3]}-${groups[4]}`;
    }
    catch (err) {
        return phoneNumber;
    }
};
/**
 * Convert a U.S. phone number to E. 164 format
 * @param {String} phoneNumber A U.S. phone number, e.g. (555) 857-6309
 * @return {String} E. 164 formatted phone number
 */
export const formatUSPhoneNumberToE164 = (phoneNumber) => {
    const groups = phoneNumber?.match(US_PHONE_NUMBER_REGEXP);
    try {
        if (!groups) {
            return phoneNumber;
        }
        return `+1${groups[2]}${groups[3]}${groups[4]}`;
    }
    catch (err) {
        return phoneNumber;
    }
};
/**
 * Progressive U.S. phone number input mask using libphonenumber-js's AsYouType.
 * Formats partial input as the user types, e.g. "5551234567" → "(555) 123-4567".
 * Digits beyond the 10th are dropped so the mask can't "fill past" a US number.
 */
export const phoneNumberMasker = (newVal) => {
    const digits = (newVal.match(/\d+/g)?.join('') ?? '').slice(0, 10);
    if (!digits)
        return '';
    // AsYouType closes the area code the moment it has three digits, e.g. "(555)". Re-masking after a
    // backspace would restore that trailing bracket immediately, stalling deletion on it, so trailing
    // separators are trimmed to keep every keystroke reversible.
    return new AsYouType('US').input(digits).replace(/[\s()-]+$/, '');
};
/**
 * Convert a E. 164 phone number to U.S. format
 * @param phoneNumber An E. 164 phone number, e.g. +15558576309
 * @returns U.S. formatted phone number, e.g. (555) 857-6309
 */
export const formatPhoneNumber = (number) => {
    if (!number)
        return '';
    if (number.toString().slice(0, 2) === '+1') {
        const groups = number.toString().match(E164_PHONE_NUMBER_REGEXP);
        if (!groups)
            return String(number);
        try {
            return `(${groups[2]}) ${groups[3]}-${groups[4]}`;
        }
        catch (err) {
            return String(number);
        }
    }
    let newVal = String(number);
    let areaCode = '';
    if (newVal[0] === '+') {
        areaCode = newVal.slice(1, 2);
        newVal = newVal.slice(2);
    }
    const onlyNumbers = newVal.match(/\d+/g)?.join('');
    if (!onlyNumbers)
        return newVal;
    const firstThree = onlyNumbers.slice(0, 3);
    const middleThree = onlyNumbers.slice(3, 6);
    const lastFour = onlyNumbers.slice(6, 10);
    const formattedNumber = `${areaCode ? `+${areaCode} ` : ''}(${firstThree}) ${middleThree}-${lastFour}`;
    return formattedNumber;
};
//# sourceMappingURL=phone-number-formatter.js.map